// Browser Notification utilities

export const requestNotificationPermission = async () => {
    if (!('Notification' in window)) {
        console.warn('This browser does not support notifications');
        return false;
    }

    if (Notification.permission === 'granted') {
        return true;
    }

    if (Notification.permission === 'denied') {
        return false;
    }

    const permission = await Notification.requestPermission();
    return permission === 'granted';
};

export const showBrowserNotification = async ({
    title,
    body,
    icon = '/assets/images/fortrade_logo.png', // change if you have custom logo
    onClick
}) => {
    const allowed = await requestNotificationPermission();
    if (!allowed) return;

    const notification = new Notification(title, {
        body,
        icon,
        badge: icon
    });

    if (onClick) {
        notification.onclick = () => {
            window.focus();
            onClick();
            notification.close();
        };
    }
};
